/*
 * @Author: liyifan 
 * @Date: 2023-07-31 19:30:51 
 * @Last Modified by: liyifan
 * @Last Modified time: 2023-08-28 15:46:44
 * @description GA埋点
 */
import { cookie, } from '@u/common'

// 写一个公共方法,发送GA事件
export const gaPushDataLayer = async(params) => {
    const CR = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
    Object.assign(params, { CR, country: CR, })
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'users_click',
        event_parameters: {
            'current_page': window.location.href,
            ...params
        }
    });
}
